import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import useStatisticsDashboard from "src/hooks/home/useStatisticsDashboard";
import SelectComp from "../shared/SelectComp";
import { DASHBOARD_STATISTIC, orderStatusFormatted, userRoleType } from "src/constant";
import WRemoveIcon from "../shared/icon/WRemoveIcon";
import WImportIcon from "../shared/icon/WImportIcon";
import WExpirateIcon from "../shared/icon/WExpirateIcon";
import useOrderSummary from "src/hooks/orders/useOrderSummary";
import useAuthGlobal from "src/context/useAuthGlobal";
import useRedirect from "src/helper/direct";

const cardHoverStyles = {
  cursor: "pointer",
  borderRadius: "10px",
  flex: 1,
  p: "17px 24px",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
  },
};

const textConfig = { fontSize: "14px", fontWeight: "bold" };
export default function HomeScreenTable() {
  const { userMe } = useAuthGlobal();
  const redirect = useRedirect();

  const [whouseId, setWHouseId] = useState();

  useEffect(() => {
    if (userMe?.role?.name === userRoleType.superAdmin) {
      setWHouseId(undefined);
      return;
    }
    setWHouseId(userMe?.currentWarehouse?._id);
  }, [userMe?._id, userMe?.currentWarehouse?._id, userMe?.role?.name]);

  const { data: statistic } = useStatisticsDashboard({ warehouse: whouseId });
  const { data: summary } = useOrderSummary({ warehouse: whouseId });
  const temp = [
    {
      id: 1,
      title: "Chờ xuất hàng",
      data: summary?.data?.warehouse[orderStatusFormatted.WaitToExport],
    },
    {
      id: 2,
      title: "Chờ lấy hàng",
      data: summary?.data?.warehouse[orderStatusFormatted.ReadyToPick],
    },
    {
      id: 3,
      title: "Đang vận chuyển",
      data: summary?.data?.warehouse[orderStatusFormatted.Delivering],
    },
    {
      id: 4,
      title: "Giao không thành công",
      data: summary?.data?.warehouse[orderStatusFormatted.DeliveredFailed],
    },
    {
      id: 5,
      title: "Đổi hàng",
      data: summary?.data?.warehouse[orderStatusFormatted.Exchange],
    },
    {
      id: 6,
      title: "Trả hàng",
      data: summary?.data?.warehouse[orderStatusFormatted.Returned],
    },
  ];

  return (
    <Grid container="12px">
      <Grid
        md={9}
        container
        item
      >
        {/* STATISTIC */}
        <Grid
          item
          xs={12}
          container
          p={0}
        >
          <Grid
            item
            xs={12}
          >
            <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>DST | Hệ thống Quản lý Kho</Typography>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ p: "0 12px 0 0", mt: "12px" }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>Tổng quan</Typography>
              <Box>
                <SelectComp
                  setValue={setWHouseId}
                  value={whouseId}
                  label="Kho"
                  item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
                  userMe={userMe}
                  disabled={userMe?.role?.name !== userRoleType.superAdmin}
                />
              </Box>
            </Box>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
              width: "100%",
              m: "24px 0",
              pr: "12px",
            }}
          >
            <Box
              onClick={() => redirect("/warehouse-management/inventory-in?tab=history-in")}
              sx={{
                ...cardHoverStyles,
                background: "var(--success)",
                "&:hover": {
                  ...cardHoverStyles["&:hover"],
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "var(--success-txt)",
                    fontSize: "28px",
                    fontWeight: "bold",
                  }}
                >
                  {statistic?.data?.warehouse[DASHBOARD_STATISTIC.totalTransfer] ?? 0}
                </Typography>
                <WImportIcon />
              </Box>
              <Typography sx={{ ...textConfig }}>Y/C Nhập kho</Typography>
            </Box>

            <Box
              onClick={() => redirect("/warehouse-management?tab=inventory-out-remove")}
              sx={{
                ...cardHoverStyles,
                background: "var(--reject)",
                "&:hover": {
                  ...cardHoverStyles["&:hover"],
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "var(--reject-txt)",
                    fontSize: "28px",
                    fontWeight: "bold",
                  }}
                >
                  {statistic?.data?.warehouse[DASHBOARD_STATISTIC.totalRequestRemove] ?? 0}
                </Typography>
                <WRemoveIcon />
              </Box>
              <Typography sx={{ ...textConfig }}>Y/C Xuất bỏ hàng hoàn</Typography>{" "}
            </Box>

            <Box
              onClick={() => redirect("/warehouse-management/inventory?tab=inventory")}
              sx={{
                ...cardHoverStyles,
                background: "var(--pending)",
                "&:hover": {
                  ...cardHoverStyles["&:hover"],
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "var(--pending-txt)",
                    fontSize: "28px",
                    fontWeight: "bold",
                  }}
                >
                  {statistic?.data?.warehouse[DASHBOARD_STATISTIC.totalNearExpire] ?? 0}
                </Typography>
                <WExpirateIcon />
              </Box>
              <Typography sx={{ ...textConfig }}>Lô sản phẩm cận date</Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          xs={12}
          item
          mb="24px"
          container
          sx={{ border: "1px solid var(--grey)", borderRadius: "12px", mr: "12px" }}
        >
          <Grid
            xs={12}
            item
            mb="24px"
          >
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              ml="24px"
              mt="24px"
              fontSize="16px"
            >
              Thống kê đơn hàng cần xử lý từ KHO
            </Typography>
          </Grid>
          {temp?.map((v) => {
            return (
              <Grid
                item
                xs={3}
                key={v?.id}
                align="center"
                mb="18px"
              >
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  mb="12px"
                  fontSize="24px"
                >
                  {v?.data ?? 0}
                </Typography>
                <Typography variant="body2">{v?.title}</Typography>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Grid
        md={3}
        item
      >
        <Box
          sx={{
            background: "var(--light-grey)",
            borderRadius: "12px",
            width: "100%",
            height: "100%",
          }}
        >
          <Typography p="24px">Không có thông báo</Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
